export default __webpack_public_path__ + "static/media/liquid.60e874a3.svg";